module.exports = __webpack_public_path__ + "img/hero-reports.7daffc8c.jpg";